import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative block size-full',
    image: 'object-cover'
  }
});
